import { AccountBalanceWallet, Visibility, VisibilityOff } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { Card, Grid2 as Grid, IconButton } from "@mui/material";
import { useState } from "react";

import AsaasLogo from "@/assets/logos/asaas-servicos-financeiros.png";
import T2PayLogo from "@/assets/logos/Talk2Pay_256X256.png";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { formatCurrency } from "@/helpers/currency-helpers";
import { AccountBalance, PlatformAccount } from "@/interfaces/talk2pay.iterfaces";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

interface Props {
  messages: T2PayHomeMessages;
  data: AccountBalance | null;
  accountInfo: PlatformAccount | null;
}

const AccountBalanceCard = ({ data, messages, accountInfo }: Props) => {
  const [isBalanceVisible, setIsBalanceVisible] = useState(false);

  const toggleBalanceVisibility = () => setIsBalanceVisible((prev) => !prev);

  const agency = accountInfo?.accountNumber?.agency;
  const account = accountInfo?.accountNumber?.account;
  const accountDigit = accountInfo?.accountNumber?.accountDigit;
  const accountDisplay =
    account && accountDigit ? `${account}-${accountDigit}` : account || "";

  return (
    <Card sx={{ px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 } }}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid>
          <img
            src={T2PayLogo}
            alt="logo t2pay"
            style={{ height: 140, width: "auto", maxWidth: 320, objectFit: "contain", display: "block" }}
          />
        </Grid>

        <Grid>
          <MDBox
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            gap={1.5}
            pt={0.5}
            pb={0.5}
          >
            <img
              src={AsaasLogo}
              alt="Serviços financeiros Asaas"
              style={{ height: 48, objectFit: "contain", display: "block" }}
            />

            <MDBox display="flex" alignItems="center" flexWrap="wrap" justifyContent="flex-end">
              <MDBox display="flex" alignItems="center" gap={0.5}>
                <AccountBalanceIcon fontSize="small" />
                <MDTypography variant="button" fontWeight="regular" color="text">
                  {messages.agencyLabel}:
                </MDTypography>
                <MDTypography variant="button" fontWeight="medium">
                  {agency}
                </MDTypography>
              </MDBox>
              <MDTypography variant="button" fontWeight="bold" color="text" mx={1.5}>
                |
              </MDTypography>
              <MDBox display="flex" alignItems="center" gap={0.5}>
                <AccountBalanceWallet fontSize="small" />
                <MDTypography variant="button" fontWeight="regular" color="text">
                  {messages.accountLabel}:
                </MDTypography>
                <MDTypography variant="button" fontWeight="medium">
                  {accountDisplay}
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox display="flex" flexDirection="column" alignItems="flex-end">
              <MDTypography variant="body2" fontWeight="regular" color="text">
                {messages.accountBalanceLabel}
              </MDTypography>
              <MDBox display="flex" alignItems="center" gap={0.5} mt={0.25}>
                <MDTypography
                  variant="h5"
                  fontWeight="bold"
                  color={isBalanceVisible ? "success" : "dark"}
                >
                  {isBalanceVisible && data ? formatCurrency(data.balance) : "****"}
                </MDTypography>
                <IconButton onClick={toggleBalanceVisibility} size="small" sx={{ p: 0.5 }}>
                  {isBalanceVisible ? (
                    <VisibilityOff sx={{ fontSize: "22px" }} />
                  ) : (
                    <Visibility sx={{ fontSize: "22px" }} />
                  )}
                </IconButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </Card>
  );
};

export default AccountBalanceCard;
